import { KpopStudyPageTemplate } from "@/components/KpopStudyPageTemplate";

const StudyWithBlackpink = () => {
  return (
    <KpopStudyPageTemplate
      groupName="BLACKPINK"
      groupNameDisplay="BLACKPINK"
      fandomName="BLINKs"
      seoTitle="Study With Blackpink - BLINK Study Rooms"
      seoDescription="Study with BLACKPINK fans worldwide. Join BLINKs in virtual study rooms with BLACKPINK playlists and themed spaces."
      seoKeywords="study with blackpink, blackpink study room, blink study, kpop study room"
      canonicalUrl="/study-with-blackpink/"
      heroDescription="Join BLINKs worldwide who study with BLACKPINK's powerful and confident energy. Stay focused and motivated."
      aboutContent={
        <>
          <p>
            <a href="https://www.blackpinkofficial.com/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">BLACKPINK</a> is a globally renowned South Korean girl group formed by <a href="https://www.ygfamily.com/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">YG Entertainment</a>. Consisting of Jisoo, Jennie, Rosé, and Lisa.
          </p>
          <p>
            BLINKs find inspiration in BLACKPINK's confidence. Follow them on <a href="https://www.instagram.com/blackpinkofficial/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Instagram</a>, <a href="https://twitter.com/BLACKPINK" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">X (Twitter)</a>, and <a href="https://www.youtube.com/@BLACKPINK" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">YouTube</a>.
          </p>
        </>
      }
      riseOfContent={
        <p>
          BLACKPINK fans have created spaces to combine their passion with productive study sessions, playing <a href="https://open.spotify.com/artist/41MozSoPIsD1dJM0CLPjZF" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">BLACKPINK's music on Spotify</a> in the background.
        </p>
      }
      featureCards={[
        { title: "BLACKPINK Study Playlists", desc: "Power through study sessions with curated BLACKPINK playlists." },
        { title: "Global BLINK Community", desc: "Connect with BLINKs from across the globe in dedicated study rooms." },
        { title: "Iconic Themed Rooms", desc: "Study in BLACKPINK-themed rooms inspired by their iconic concepts." },
        { title: "Always Available", desc: "Join BLACKPINK study sessions 24/7." },
      ]}
      whyPerfectDescription="CSW is more than just a study platform; it's a place where fans of BLACKPINK can come together, stay motivated, and achieve their goals."
      communityDescription1="CSW – Chill Study Work is more than just a study platform; it's a place to connect with like-minded individuals."
      communityDescription2="Discover how studying with your favorite idols can transform your academic journey."
      socialLinks={[
        { name: "Official Website", url: "https://www.blackpinkofficial.com/" },
        { name: "YouTube", url: "https://www.youtube.com/@BLACKPINK" },
        { name: "Instagram", url: "https://www.instagram.com/blackpinkofficial/" },
        { name: "X (Twitter)", url: "https://twitter.com/BLACKPINK" },
        { name: "Spotify", url: "https://open.spotify.com/artist/41MozSoPIsD1dJM0CLPjZF" },
      ]}
      youtubeVideos={[
        { id: "IHNzOHi8sJs", title: "BLACKPINK - Pink Venom M/V" },
        { id: "POe9SOEKotk", title: "BLACKPINK - Shut Down M/V" },
        { id: "ioNng23DkIM", title: "BLACKPINK - How You Like That M/V" },
        { id: "2S24-y0Ij3Y", title: "BLACKPINK - Kill This Love M/V" },
        { id: "Lu0IvnVRaDQ", title: "BLACKPINK - DDU-DU DDU-DU M/V" },
        { id: "Amq-qlqbjYA", title: "BLACKPINK - Lovesick Girls M/V" },
      ]}
      youtubeChannelUrl="https://www.youtube.com/@BLACKPINK"
      youtubeChannelName="BLACKPINK"
    />
  );
};

export default StudyWithBlackpink;
